<div class="layout-footer">
  <div class="footer">
    <img class="footer__logo" src="assets/images/Agilysys.png" alt="agilysys-logo">
  </div>
</div>